export default {
  init() {
    // JavaScript to be fired on all pages
    console.log('handcrafted by');
    console.log('\n' +
        '  ___   _    ___________  ___  ___  ___  ___  ______  _____   ___  \n' +
        ' / _ \\ | |  |_   _| ___ \\/ _ \\ |  \\/  | / _ \\ | ___ \\/  __ \\ / _ \\ \n' +
        '/ /_\\ \\| |    | | | |_/ / /_\\ \\| .  . |/ /_\\ \\| |_/ /| /  \\// /_\\ \\\n' +
        '|  _  || |    | | |    /|  _  || |\\/| ||  _  ||    / | |    |  _  |\n' +
        '| | | || |____| | | |\\ \\| | | || |  | || | | || |\\ \\ | \\__/\\| | | |\n' +
        '\\_| |_/\\_____/\\_/ \\_| \\_\\_| |_/\\_|  |_/\\_| |_/\\_| \\_| \\____/\\_| |_/\n' +
        '                                                                   \n' +
        '                                                                   \n');
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js